export default __webpack_public_path__ + "static/media/the-colin-and-samir-podcast@2x (1) 2.31494afd.png";